// dependencies
import { useCallback, useState, useMemo } from "react";
import { useEffectOnce } from "@swiggy-private/core-ui";

// constants
import { CHECKOUT_WEB_WP, CHECKOUT_WEB_XP } from "@checkout-core/constants/CheckoutWebDynamicConfig";

// contexts
import { CheckoutWebDynamicConfigContextValue } from "@checkout-core/contexts/CheckoutDynamicConfigContext";

//utils
import { getCheckoutWebDynamicConfigValues } from "@checkout-core/utils";

export const useCheckoutWebDynamicConfig = () => {
    const [checkoutWebXP, setCheckoutWebXP] = useState<CheckoutWebDynamicConfigContextValue["checkoutWebXP"]>({});
    const [checkoutWebWP, setCheckoutWebWP] = useState<CheckoutWebDynamicConfigContextValue["checkoutWebWP"]>({});

    const getCheckoutDynamicConfigValue = useCallback(async () => {
        const payload = {
            xpKeyList: Object.values(CHECKOUT_WEB_XP),
            wpKeyList: Object.values(CHECKOUT_WEB_WP),
        };

        const configValues = await getCheckoutWebDynamicConfigValues(payload);

        setCheckoutWebXP(prevXpValues => ({ ...prevXpValues, ...configValues?.xpValues }));
        setCheckoutWebWP(prevWpValues => ({ ...prevWpValues, ...configValues?.wpValues }));
    }, []);

    // get the config values from native method
    useEffectOnce(() => {
        getCheckoutDynamicConfigValue();
    });

    return useMemo(() => ({ checkoutWebXP, checkoutWebWP }), [checkoutWebXP, checkoutWebWP]);
};
